import { SqlColumnDefinition } from "@reporting/rp-types/mdm";

export enum MdmColTypes {
    Text = 'T',
    Checkbox = 'CH',
    Dropdown = 'S',
    Date = 'D',
    Integer = 'I',
    Float = 'F',
    Treelist = 'L',
    JSON = 'J'
};

export const MDM_TABLE_COL_TYPES = [
    { k: MdmColTypes.Text, v: 'Text' }, // default value
    { k: MdmColTypes.Checkbox, v: 'Checkbox' },
    { k: MdmColTypes.Dropdown, v: 'Dropdown' },
    { k: MdmColTypes.Date, v: 'Date' },
    { k: MdmColTypes.Integer, v: 'Integer' },
    { k: MdmColTypes.Float, v: 'Float' },
    { k: MdmColTypes.Treelist, v: 'Treelist' },
    { k: MdmColTypes.JSON, v: 'JSON' }
];

export const MDM_TABLE_COL_TYPES_MAP = [
    { colType: MdmColTypes.Text, t: 't' },
    { colType: MdmColTypes.Checkbox, t: 'b' },
    { colType: MdmColTypes.Dropdown, t: 's' },
    { colType: MdmColTypes.Date, t: 'd' },
    { colType: MdmColTypes.Integer, t: 'n' },
    { colType: MdmColTypes.Float, t: 'n' },
    { colType: MdmColTypes.Treelist, t: 's' },
    { colType: MdmColTypes.JSON, t: 't' }
];

export const SQL_TABLE_DEF_DEFAULTS = [
    {
        column_name: 'IDZ',
        data_type: 'bigint',
        is_nullable: 0
    }, {
        column_name: 'VALIDATE_FLAG',
        data_type: 'bit',
        is_nullable: 1,
        COLUMN_DEFAULT: 1
    }, {
        column_name: 'ACCOUNTING',
        data_type: 'int',
        is_nullable: 1
    }, {
        column_name: 'WHO_CREATED',
        data_type: 'nvarchar(50)',
        is_nullable: 1
    }, {
        column_name: 'DATE_CREATED',
        data_type: 'datetime',
        is_nullable: 1,
        column_default: '(getdate())'
    }, {
        column_name: 'WHO_DELETED',
        data_type: 'nvarchar(50)',
        is_nullable: 1
    }, {
        column_name: 'DATE_DELETED',
        data_type: 'datetime',
        is_nullable: 1
    }
] as unknown as SqlColumnDefinition[];

export const SQL_READ_ONLY_COLS = [
    'IDZ',
];

export enum TableTypes {
    MDM = 'MDM',
    SQL = 'SQL'
}

export type TableType = 'MDM' | 'SQL';

export type MdmJsonColumnDefinition = {
	key?: string;
	name?: string;
	type?: string;
	id_md?: number;
	ro?: boolean;
	pattern?: string;
	ord?: number;
	opt?: string;
}
